import { IconStylingModel } from '../models/icon/icon-styling.model';
import { SelectOptionModel } from '../models/select/select-option.model';
import { SelectOptionStylingModel } from '../models/select/select-option-styling.model';

export const /** @type {?} */ SelectOptionTemplates = {
  defaultTemplate: {
    property: new SelectOptionModel({
      display: true,
      disable: false,
      option: null,
      value: null,
      label: null,
      item: null,
      icon: null,
      optionValueField: 'value',
      optionLabelField: 'label',
      optionItemField: 'item',
      optionIconField: 'icon',
    }),
    style: new SelectOptionStylingModel()
  }
}
